import { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: 'my-account',
    name: 'settings.my-account',
    component: () => import('@/views/control-panel/settings/MyAccount.vue'),
  },
  {
    path: 'system',
    name: 'settings.system',
    component: () => import('@/views/control-panel/settings/System.vue'),
  }
]

export default routes
